import { render, staticRenderFns } from "./CrearProducto.vue?vue&type=template&id=52d6e794&scoped=true"
import script from "./CrearProducto.vue?vue&type=script&lang=js"
export * from "./CrearProducto.vue?vue&type=script&lang=js"
import style0 from "./CrearProducto.vue?vue&type=style&index=0&id=52d6e794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6e794",
  null
  
)

export default component.exports